import moment from 'moment'

import {
  getCurrentQuestionById,
  type GetCurrentQuestionByIdProps,
} from './getCurrentQuestionById'

export const getChartFormattedData = ({
  data,
  questionId,
}: GetCurrentQuestionByIdProps) => {
  if (!data || !questionId) {
    return []
  }

  const findQuestionById = getCurrentQuestionById({ data, questionId })

  const transformMeasures =
    findQuestionById?.measures?.map((measure) => ({
      id: measure.id,
      score: Number(measure.answer_value),
      date: moment(measure.answer_date).toDate(),
    })) || []

  const sortedMeasures = [...transformMeasures].sort(
    (a, b) => a.date.getTime() - b.date.getTime()
  )

  return sortedMeasures.map((score) => {
    const formattedDate = moment(score.date).format('MMM D, yyyy')

    return {
      date: formattedDate,
      score: score.score,
      timestamp: formattedDate,
    }
  })
}

export type ChartFormattedDataModel = ReturnType<typeof getChartFormattedData>
